import Vue from 'vue'
import {
  Popover,
  Tabs,
  TabPane,
  TableColumn,
  Backtop,
  Icon,
  Breadcrumb,
  BreadcrumbItem,
  Select,
  Option,
  Cascader,
  RadioGroup,
  Radio,
  Form,
  FormItem,
  Input,
  Message
} from 'element-ui'

const components = [
  Popover,
  Tabs,
  TabPane,
  TableColumn,
  Backtop,
  Icon,
  Breadcrumb,
  BreadcrumbItem,
  Select,
  Option,
  Cascader,
  RadioGroup,
  Radio,
  Form,
  FormItem,
  Input
]

Vue.prototype.$message = Message

export default {
  install (Vue, option = {}) {
    components.map(c => {
      Vue.use(c)
    })
  }
}
